var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import React from 'react';
import { CurrencyRupee, Percent } from '@mui/icons-material';
import { FormItemTypes } from '../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity';
import { PlusHeaderIcon } from '../../../assets/customIcons';
import { DynamicFormBuilderContainer } from '../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container';
import { ReactComponent as CloseIcon } from '../../../assets/images/close.svg';
var ContractDetails = function (_ref) {
    var onClose = _ref.onClose, data = _ref.data;
    var formData = [{
            type: FormItemTypes.ContainerItem,
            name: '',
            padding: '16px 20px',
            columnSize: 12,
            spacing: 0,
            justifyContent: 'space-between',
            alignItems: 'center',
            elements: [{
                    type: FormItemTypes.Typography,
                    name: '',
                    children: 'Contract details',
                    columnSize: 0,
                    fontSize: 'xl',
                    fontWeight: 'strong'
                }, {
                    type: FormItemTypes.IconButton,
                    name: '',
                    children: /*#__PURE__*/ React.createElement(CloseIcon, {
                        color: "#6A7682",
                        height: '20px',
                        width: '20px'
                    }),
                    columnSize: 0,
                    onClick: function () {
                        onClose(false);
                    }
                }]
        }, {
            type: FormItemTypes.ContainerItem,
            name: '',
            padding: '20px',
            columnSize: 12,
            spacing: 0,
            borderTop: '1px solid',
            borderColor: 'DEE4EB',
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: 12,
                    border: '1px solid',
                    borderColor: '#DEE4EB',
                    borderRadius: '12px',
                    padding: '16px',
                    gap: '12px',
                    spacing: 0,
                    paddingBottom: 10,
                    elements: [{
                            type: FormItemTypes.ContainerItem,
                            name: '',
                            columnSize: 12,
                            spacing: 0,
                            justifyContent: 'space-between',
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: '',
                                    children: '#CNT-2025-002',
                                    columnSize: 0,
                                    fontWeight: 'medium',
                                    fontSize: 'sm',
                                    color: '#6A7682'
                                }, {
                                    type: FormItemTypes.Chip,
                                    name: '',
                                    label: 'New',
                                    color: 'warning',
                                    size: 'small',
                                    sx: {
                                        borderRadius: '6px'
                                    },
                                    columnSize: 0
                                }]
                        }, {
                            type: FormItemTypes.Typography,
                            name: '',
                            children: 'Contract name- comprehensive cover',
                            columnSize: 12,
                            fontSize: 'lg',
                            fontWeight: 'medium'
                        }, {
                            type: FormItemTypes.Typography,
                            name: '',
                            label: 'SAC Code:',
                            value: null,
                            children: "9090",
                            containerProps: {
                                display: 'inline-flex',
                                alignItems: 'baseline',
                                gap: 1
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true,
                                fontWeight: 'strong'
                            },
                            columnSize: 12
                        }, {
                            type: FormItemTypes.Typography,
                            name: '',
                            children: 'Description text-The component should be clean, well-structured, and visually engagi..',
                            columnSize: 12
                        }, {
                            type: FormItemTypes.NumberInput,
                            name: 'Discount',
                            label: 'Discount',
                            value: null,
                            columnSize: 4,
                            InputProps: {
                                endAdornment: /*#__PURE__*/ React.createElement(Percent, {
                                    height: 2,
                                    width: 2
                                })
                            }
                        }, {
                            type: FormItemTypes.NumberInput,
                            name: 'Amount',
                            value: null,
                            columnSize: 7,
                            sx: {
                                mt: 2.8
                            },
                            InputProps: {
                                endAdornment: /*#__PURE__*/ React.createElement(CurrencyRupee, {
                                    height: 2,
                                    width: 2
                                })
                            }
                        }, {
                            type: FormItemTypes.Box,
                            name: '',
                            columnSize: 12,
                            borderRadius: '8px',
                            padding: '12px',
                            bgcolor: '#F4F7FA',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '10px',
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: '',
                                    children: 'Renew conditions',
                                    fontWeight: 'strong',
                                    columnSize: 12
                                }, {
                                    type: FormItemTypes.Divider,
                                    name: '',
                                    variant: 'fullWidth',
                                    columnSize: 12
                                }, {
                                    type: FormItemTypes.Custom,
                                    name: '',
                                    columnSize: 12,
                                    element: function () { /*#__PURE__*/ return React.createElement("ol", {
                                        style: {
                                            paddingLeft: '12px',
                                            fontSize: 'sm',
                                            color: '#6A7682'
                                        }
                                    }, /*#__PURE__*/ React.createElement("li", null, "This contract can be renew max (3) times."), /*#__PURE__*/ React.createElement("li", null, "This contract can be renew max (3) times.This contract can be renew before 30 days of expiry date & 45 days after the date")); }
                                }]
                        }, {
                            type: FormItemTypes.Box,
                            name: '',
                            columnSize: 12,
                            borderRadius: '8px',
                            padding: '12px',
                            bgcolor: '#F4F7FA',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '10px',
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: '',
                                    children: 'Return conditions',
                                    fontWeight: 'strong',
                                    columnSize: 12
                                }, {
                                    type: FormItemTypes.Divider,
                                    name: '',
                                    variant: 'fullWidth',
                                    columnSize: 12
                                }, {
                                    type: FormItemTypes.Custom,
                                    name: '',
                                    columnSize: 12,
                                    element: function () { /*#__PURE__*/ return React.createElement("ol", {
                                        style: {
                                            paddingLeft: '12px',
                                            fontSize: 'sm',
                                            color: '#6A7682'
                                        }
                                    }, /*#__PURE__*/ React.createElement("li", null, "Return is allowed in 45 days after the invoiced date"), /*#__PURE__*/ React.createElement("li", null, "Contract should not be consumed")); }
                                }]
                        }]
                }]
        },
        // {
        //     type: FormItemTypes.ContainerItem,
        //     name: '',
        //     paddingInline: '24px',
        //     columnSize: 12,
        //     height: '83px',
        //     padding: '24px',
        //     spacing: 0,
        //     gap: '12px',
        //     elements: [
        //         {
        //             type: FormItemTypes.Divider,
        //             name: '',
        //             variant: 'fullWidth',
        //             columnSize: 12,
        //         },
        //         {
        //             type: FormItemTypes.ContainerItem,
        //             name: '',
        //             columnSize: 12,
        //             direction: 'row',
        //             justifyContent: 'space-between',
        //             elements: [
        //                 {
        //                     type: FormItemTypes.Typography,
        //                     name: '',
        //                     label: '₹ 27,097.00',
        //                     children: 'Taxes - 9090(18%)',
        //                     columnSize: 6,
        //                     fontSize: 'sm',
        //                     color: 'secondary.600',
        //                     labelTypographyProps: {
        //                         fontSize: 'lg',
        //                         fontWeight: 'strong',
        //                         color: 'black'
        //                     }
        //                 },
        //                 {
        //                     type: FormItemTypes.Button,
        //                     name: '',
        //                     variant: 'contained',
        //                     children: 'Add',
        //                     columnSize: 3,
        //                     sx: {
        //                         position: 'absolute',
        //                         display: 'flex',
        //                         justifyContent: 'end'
        //                     },
        //                     startIcon: <PlusHeaderIcon />
        //                 }
        //             ]
        //         }
        //     ]
        // },
        {
            type: FormItemTypes.ContainerItem,
            name: '',
            paddingInline: '24px',
            columnSize: 12,
            height: '83px',
            padding: '24px',
            spacing: 0,
            gap: '12px',
            position: 'absolute',
            bottom: 0,
            elements: [{
                    type: FormItemTypes.Divider,
                    name: '',
                    variant: 'fullWidth',
                    columnSize: 12
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: 'ContractDetailsFooter',
                    columnSize: 12,
                    direction: 'row',
                    justifyContent: 'space-between',
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: '',
                            children: '₹ 27,097.00',
                            columnSize: 0,
                            fontSize: 'lg',
                            fontWeight: 'strong'
                        }, {
                            type: FormItemTypes.Button,
                            name: 'AddContractDetails',
                            variant: 'contained',
                            children: 'Add',
                            columnSize: 0,
                            onClick: function () { return 'submit'; },
                            startIcon: /*#__PURE__*/ React.createElement(PlusHeaderIcon, null)
                        }]
                }]
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        gridProps: {
            spacing: 0,
            sx: {
                paddingTop: {
                    sx: 0,
                    sm: 0,
                    md: '60px',
                    lg: '60px'
                }
            }
        },
        formData: formData,
        mode: "edit",
        getFormAPI: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, ({
                        data: data,
                        success: true
                    })];
            });
        }); },
        updateFormAPI: function (_ref2) { return __awaiter(void 0, void 0, void 0, function () {
            var request;
            return __generator(this, function (_a) {
                request = _ref2.request;
                onClose(_objectSpread(_objectSpread({}, request), {}, {
                    isAdded: true
                }));
                return [2 /*return*/, {
                        success: true
                    }];
            });
        }); }
    }));
};
export default ContractDetails;
